module.exports = __webpack_public_path__ + "static/media/bannerDesktop.ba550a39.png";